import { useEffect } from 'react';
import Icons from '../../utilities/icons';
import KmxCloseStroked from '@kmx/mui-icons/KmxCloseStroked';
import IneligibleOffer from './IneligibleOffer';
import {
    instantOfferEligibleEvent,
    instantOffersContainerId,
    instantOffersDialogContainerClassName,
} from './utils/constants';
import { IInstantOfferDetails } from './InstantOffers';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

interface IInstantOffersFullScreenDialogProps {
    isOpen: boolean;
    isLoading: boolean;
    onClose: () => void;
    isInstantOffersEligible: boolean;
    instantOfferDetails: IInstantOfferDetails;
}

function InstantOffersFullScreenDialog({
    isOpen,
    isLoading,
    onClose,
    isInstantOffersEligible,
    instantOfferDetails,
}: IInstantOffersFullScreenDialogProps) {
    const scrollToTop = () => {
        const icoContainerEl = document.querySelector(`.${instantOffersDialogContainerClassName}`);
        if (icoContainerEl) {
            if ('scrollBehavior' in document.documentElement.style) {
                icoContainerEl.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            } else {
                icoContainerEl.scrollTop = 0;
            }
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.documentElement.classList.add('kmx-suyc-ico-open');
            window.addEventListener(instantOfferEligibleEvent, scrollToTop);
        } else {
            document.documentElement.classList.remove('kmx-suyc-ico-open');
            window.removeEventListener(instantOfferEligibleEvent, scrollToTop);
        }
    }, [isOpen]);

    // TODO  update background to "secondaryFaint" and heading border to "elevation.outlined" or equivalent when available

    return (
        <Dialog fullScreen open={isOpen} keepMounted>
            <DialogTitle sx={{ py: 0, pr: 1, pl: 2, height: '3rem' }}>
                <Box sx={{ ['&>svg']: { height: '1.5rem' }, display: 'flex', alignContent: 'center' }}>
                    {Icons.carMaxLogoDark}
                </Box>
                <IconButton size="medium" onClick={onClose} aria-label="Close Instant Offers Dialog">
                    <KmxCloseStroked />
                </IconButton>
            </DialogTitle>
            <DialogContent
                dividers
                sx={({ palette }) => ({
                    height: '100%',
                    alignContent: 'center',
                    backgroundColor: palette.secondary.faint,
                })}
            >
                <Box id={instantOffersContainerId} sx={{ display: `${isInstantOffersEligible ? 'block' : 'none'}` }} />
                {!isLoading && !isInstantOffersEligible && (
                    <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <IneligibleOffer instantOfferDetails={instantOfferDetails} />
                    </Stack>
                )}
            </DialogContent>
        </Dialog>
    );
}

export default InstantOffersFullScreenDialog;
